<template>
  <div ref="page" class="search">
    <div class="search-bar-wrap">
      <el-input
        placeholder="输入职位关键词"
        v-model="searchText"
        class="search-bar"
        :size="searchBarSize"
      >
        <el-button slot="append" type="primary" @click="search"
          >搜索职位</el-button
        >
      </el-input>
    </div>
    <div v-if="jobs.length > 0" class="search-result">
      <a
        v-for="(job, index) in jobs"
        :key="index"
        :href="
          $root.env.VUE_APP_JOBDESC_PAGE +
          '?jobid=' +
          job.Id +
          '&fromGroup=' +
          fromGroup
        "
        target="_blank"
        class="job-item"
      >
        <h3 class="job-title">{{ job.Name }}</h3>
        <p class="job-info">{{ job.Type }} {{ job.WorkPlace }}</p>
      </a>
    </div>
    <div v-else-if="isLoaded" class="result-empty">
      <i class="el-icon-warning-outline" style="color: #e6a23c"></i>
      找不到匹配的数据，请尝试更换搜索关键字
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data() {
    return {
      searchText: '',
      searchBarSize: 'default',
      jobs: [],
      isLoaded: false,
    }
  },
  created() {
    this.getJob()
  },
  computed: {
    fromGroup() {
      return this.$route.query.fromGroup || 'school'
    },
  },
  mounted() {
    this.setIframeHeight()
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  destroyed() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      this.searchBarSize =
        document.body.clientWidth > 768 ? 'default' : 'medium'
    },
    setIframeHeight() {
      this.$nextTick(() => {
        window.parent.postMessage(
          {
            callback: 'setIframeHeight',
            args: [this.$refs.page.scrollHeight + 50],
          },
          '*'
        )
      })
    },
    search() {
      this.getJob(this.searchText)
    },
    getJob(searchText) {
      this.$apiGet('/recruit/getJob', {
        fromGroup: this.fromGroup,
        searchText,
      })
        .then((data) => {
          this.isLoaded = true
          this.jobs = data || []
          this.setIframeHeight()
        })
        .catch((error) => {
          this.isLoaded = true
          if (this.$isServerFail(error)) {
            console.error(error)
            alert('搜索职位发生错误')
          }
        })
    },
  },
}
</script>
<style lang="less">
.search {
  .search-bar-wrap {
    width: 60%;
    margin: 0 auto 4%;
    .search-bar {
      .el-input-group__append {
        background-color: #028be6;
        border-color: #028be6;
        color: #fff;
      }
      .el-input__inner {
        border-right: none;
      }
      .el-input__inner:focus {
        border-color: #028be6;
      }
    }
  }
  .search-result {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    place-items: center;
    color: #f3f3f3;
    text-align: center;
    overflow: hidden;
    .job-item {
      width: 100%;
      border-radius: 15px;
      padding: 19% 0;
      // background-image: linear-gradient(180deg, #0dcbff, #028be6);
      background-image: linear-gradient(180deg, #43dac4, #2bbdd0 60%, #0b96e1);
      -webkit-transition: all 0.3s ease;
      transition: all ease 0.3s;
      color: inherit;
      text-decoration: none;
      &:hover {
        box-shadow: 5px 4px 11px 2px rgba(0, 49, 96, 0.31);
        transform: scale(1.01);
      }
      .job-title {
        font-size: 22px;
        margin: 0 0 20px;
      }
      .job-info {
        color: inherit;
        font-size: 14px;
        margin: 0;
      }
    }
    .result-empty {
      padding-top: 3%;
      font-size: 18px;
    }
  }
  @media (min-width: 768px) {
    .search-result {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 35px;
      place-items: center;
      color: #f3f3f3;
      text-align: center;
      .job-item {
        width: 100%;
        border-radius: 25px;
        padding: 19% 0;
        // background-image: linear-gradient(180deg, #0dcbff, #028be6);
        background-image: linear-gradient(
          180deg,
          #43dac4,
          #2bbdd0 60%,
          #0b96e1
        );
        -webkit-transition: all 0.3s ease;
        transition: all ease 0.3s;
        color: inherit;
        text-decoration: none;
        &:hover {
          box-shadow: 5px 4px 11px 2px rgba(0, 49, 96, 0.31);
          transform: scale(1.01);
        }
        .job-title {
          font-size: 22px;
          margin: 0 0 20px;
        }
        .job-info {
          color: inherit;
          font-size: 14px;
          margin: 0;
        }
      }
      .result-empty {
        padding-top: 3%;
        font-size: 18px;
      }
    }
  }
}
</style>
